import React from 'react';
export var HoverContainerContext = /*#__PURE__*/React.createContext({});
export var HoverContainerProvider = HoverContainerContext.Provider;